export default {
  sm: `
  구봉산 자락의 자연과 조화를 이룬 데이터센
  터 각 춘천은 안정적이고 빠른 IT 서비스를
  제공하기 위해 다양한 기술을 검토하고 적용
  했습니다. 각 춘천은 자연에 끼치는 영향을 
  최소화하며, 효율을 극대화한 네이버의
  첫 번째 친환경 데이터센터입니다.
  `,
  md: `
  구봉산 자락의 자연과 조화를 이룬 데이터센터 각 춘천은 안정적이고 
  빠른 IT 서비스를 제공하기 위해 다양한 기술을 검토하고 적용했습니다. 
  각 춘천은 자연에 끼치는 영향을 최소화하며, 효율을 극대화한 
  네이버의 첫 번째 친환경 데이터센터입니다.
  `
};
